import SkatePersonalizationCallOut from "./SkatePersonalizationCallOut";
export default SkatePersonalizationCallOut;
